import { render, staticRenderFns } from "./GroupLastUpdate.vue?vue&type=template&id=0422d828&scoped=true&"
import script from "./GroupLastUpdate.vue?vue&type=script&lang=ts&"
export * from "./GroupLastUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./GroupLastUpdate.vue?vue&type=style&index=0&id=0422d828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422d828",
  null
  
)

export default component.exports